import { useState } from 'react';
import { Button, Input, Card, Avatar, Badge, Spinner } from '../../components/ui';

export function ComponentShowcase(): JSX.Element {
    const [val, setVal] = useState('');

    return (
        <div className="p-8 space-y-8 max-w-4xl mx-auto text-text-primary">
            <h1 className="text-2xl font-heading font-bold mb-4">Component Showcase</h1>

            <section className="space-y-4">
                <h2 className="text-xl font-heading font-semibold border-b border-border-subtle pb-2">Buttons</h2>
                <div className="flex gap-4 items-center flex-wrap">
                    <Button variant="primary">Primary</Button>
                    <Button variant="secondary">Secondary</Button>
                    <Button variant="ghost">Ghost</Button>
                    <Button variant="primary" size="sm">Small</Button>
                    <Button variant="primary" size="lg">Large</Button>
                    <Button variant="primary" disabled>Disabled</Button>
                </div>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-heading font-semibold border-b border-border-subtle pb-2">Inputs</h2>
                <div className="max-w-md space-y-4">
                    <Input label="Regular Input" placeholder="Type something..." value={val} onChange={setVal} />
                    <Input label="Error Input" error="This field is required" placeholder="Error state" value="" onChange={() => { }} />
                    <Input label="Disabled Input" disabled placeholder="Disabled state" value="" onChange={() => { }} />
                </div>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-heading font-semibold border-b border-border-subtle pb-2">Cards</h2>
                <div className="grid grid-cols-2 gap-4">
                    <Card>
                        <h3 className="font-semibold mb-2">Regular Card</h3>
                        <p className="text-text-secondary text-sm">Static surface with elevated background.</p>
                    </Card>
                    <Card onClick={() => { }}>
                        <h3 className="font-semibold mb-2">Interactive Card</h3>
                        <p className="text-text-secondary text-sm">Cards can be clickable and have hover states.</p>
                    </Card>
                </div>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-heading font-semibold border-b border-border-subtle pb-2">Avatars</h2>
                <div className="flex gap-4 items-center">
                    <Avatar name="John Doe" size="lg" />
                    <Avatar name="Alice" size="md" />
                    <Avatar name="Bob" size="sm" />
                    <Avatar name="Anima AI" isAI size="lg" />
                    <Avatar name="Anima" isAI size="md" />
                </div>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-heading font-semibold border-b border-border-subtle pb-2">Badges</h2>
                <div className="flex gap-4 items-center">
                    <Badge variant="active">Active</Badge>
                    <Badge variant="waiting">Waiting</Badge>
                    <Badge variant="resolved">Resolved</Badge>
                    <Badge variant="ai">Anima Draft</Badge>
                </div>
            </section>

            <section className="space-y-4">
                <h2 className="text-xl font-heading font-semibold border-b border-border-subtle pb-2">Loading</h2>
                <div className="flex gap-4 items-center text-accent-brand">
                    <Spinner size="sm" />
                    <Spinner size="md" />
                    <Spinner size="lg" />
                </div>
            </section>
        </div>
    );
}
